import React, { Fragment } from 'react';

const colorConversionUtils = {
    conversionKeyLength: (conversion, colorValue) => conversion(colorValue).length,

    conversionResults: (conversion, colorValue) => {
        const results = conversion(colorValue).map((item, index) => {
            return (
                <Fragment key={index}>
                    {item}
                    {!(
                        index + 1 ===
                        colorConversionUtils.conversionKeyLength(conversion, colorValue)
                    ) && ','}
                </Fragment>
            );
        });
        return results;
    },

    conversionResultValue: (conversion, colorValue) =>
        conversion(colorValue)
            .map(
                (item, index) =>
                    `${item}${
                        !(
                            index + 1 ===
                            colorConversionUtils.conversionKeyLength(conversion, colorValue)
                        )
                            ? ','
                            : ''
                    }`,
            )
            .join(''),
};

export default colorConversionUtils;
